import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { enterpriseInviteBulkRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { enterpriseCodeKey } from '@features/applications';

type useInviteEnterpriseBulkProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  setSuccessText?: Dispatch<SetStateAction<string>>;
};

export const useInviteEnterpriseBulk = ({
  setErrorText = () => { },
  setSuccessText = () => { },
}: useInviteEnterpriseBulkProps) => {
  const client = useQueryClient();

  const { mutate: inviteEnterpriseBulk, isLoading: isInvitingEnterpriseBulk } =
    useMutation({
      mutationFn: () =>
        axiosInstance
          .post(enterpriseInviteBulkRoute)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          setSuccessText(data.message)
          client.invalidateQueries([enterpriseCodeKey]);
        }
      },
      onError: () => setErrorText(errorMessage),
    });
  return {
    inviteEnterpriseBulk,
    isInvitingEnterpriseBulk,
  };
};
